import React, { useMemo, useState } from "react";
import RfmModalBase from "./RfmModalBase";

const TYPES = [
  { id: "wall-h", icon: "bi bi-dash-lg", label: "Pared H", defW: 4, defH: 1 },
  { id: "wall-v", icon: "bi bi-grip-vertical", label: "Pared V", defW: 1, defH: 4 },
  { id: "plant", icon: "bi bi-flower1", label: "Planta", defW: 1, defH: 1 },
  { id: "counter", icon: "bi bi-box", label: "Mostrador", defW: 3, defH: 1 },
];

export default function RfmCreateObjectModal({ open, onClose, zones = [], defaultZoneId, onCreate }) {
  const [type, setType] = useState("wall-h");
  const [zoneId, setZoneId] = useState(defaultZoneId || zones?.[0]?.id || "");
  const [w, setW] = useState(3);
  const [h, setH] = useState(1);
  const [label, setLabel] = useState("");

  const typeMeta = useMemo(() => TYPES.find((t) => t.id === type), [type]);

  const setTypeAndDefaults = (id) => {
    const meta = TYPES.find((t) => t.id === id);
    setType(id);
    setW(meta?.defW ?? 3);
    setH(meta?.defH ?? 1);
  };

  const submit = () => {
    onCreate?.({
      type,
      zone: zoneId || defaultZoneId || zones?.[0]?.id,
      gridW: Number(w) || 1,
      gridH: Number(h) || 1,
      posx: 0,
      posy: 0,
      label: label.trim(),
    });
    setLabel("");
    onClose?.();
  };

  return (
    <RfmModalBase
      open={open}
      title="Nuevo Objeto"
      onClose={onClose}
      footer={
        <>
          <button className="rfm-btn rfm-btn-secondary" type="button" onClick={onClose}>Cancelar</button>
          <button className="rfm-btn rfm-btn-primary" type="button" onClick={submit}>
            <i className="bi bi-plus-lg" /> Crear
          </button>
        </>
      }
    >
      <div className="rfm-form-group">
        <label className="rfm-form-label">Tipo de Objeto</label>
        <div className="rfm-object-selector">
          {TYPES.map((t) => (
            <div
              key={t.id}
              className={`rfm-object-option ${type === t.id ? "active" : ""}`}
              onClick={() => setTypeAndDefaults(t.id)}
            >
              <i className={t.icon} />
              <span>{t.label}</span>
            </div>
          ))}
        </div>
        <div style={{ marginTop: 6, fontSize: "0.7rem", color: "var(--text-muted)" }}>
          Seleccionado: <strong>{typeMeta?.label}</strong>
        </div>
      </div>

      {/* <div className="rfm-form-group">
        <label className="rfm-form-label">Zona</label>
        <select className="rfm-form-input" value={zoneId} onChange={(e) => setZoneId(e.target.value)}>
          {zones.map((z) => <option key={z.id} value={z.id}>{z.name}</option>)}
        </select>
      </div> */}

      <div className="rfm-form-group">
        <label className="rfm-form-label">Tamaño (celdas)</label>
        <div className="rfm-size-selector">
          <div className="rfm-size-group">
            <label>Ancho:</label>
            <input type="number" min={1} max={10} value={w} onChange={(e) => setW(e.target.value)} />
          </div>
          <div className="rfm-size-group">
            <label>Alto:</label>
            <input type="number" min={1} max={10} value={h} onChange={(e) => setH(e.target.value)} />
          </div>
        </div>
      </div>

      <div className="rfm-form-group">
        <label className="rfm-form-label">Etiqueta (opcional)</label>
        <input className="rfm-form-input" value={label} onChange={(e) => setLabel(e.target.value)} placeholder="Ej: Barra, Entrada..." />
      </div>
    </RfmModalBase>
  );
}
